import configuration from "./ReportConfiguration.module.css"
import document from "./ReportDocument.module.css"
import empty from "./ReportEmpty.module.css"
import layout from "./ReportLayout.module.css"
import responsive from "./ReportResponsive.module.css"
import revision from "./ReportRevision.module.css"
import steering from "./ReportSteering.module.css"

const sheets: Record<string, string>[] = [
  layout,
  configuration,
  document,
  responsive,
  steering,
  empty,
  revision,
]

/** Shared document selectors retain their module scope across layout sheets. */
export function reportClass(names: string): string {
  return names
    .split(/\s+/)
    .filter(Boolean)
    .flatMap((name) => {
      const matches = sheets.map((sheet) => sheet[name]).filter(Boolean)
      return matches.length ? matches : [name]
    })
    .join(" ")
}
